import React, { useEffect, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { TodayOfferCard } from './TodayOfferCard';
import { CHECKOUT_URL } from '../data/content';
const rows: [string, string][] = [['Vol 1 — A1 Foundations', '$27 USD'], ['Vol 2 — A1 Everyday Life', '$27 USD'], ['Vol 3 — A2 Confidence Builder', '$27 USD'], ['Vol 4 — A2 Real-World Communication', '$27 USD'], ['Vol 5 — B1 Fluency Essentials', '$27 USD'], ['Vol 6 — B1 Independent Speaker', '$27 USD'], ['Bonus 1 — ESL Grammar Rescue Kit', '$47 USD'], ['Bonus 2 — 52 Weekly ESL Themes', '$47 USD'], ['Bonus 3 — Classroom Script Library', '$47 USD'], ['Bonus 4 — ESL Assessment Toolkit', '$47 USD']];
export function ValueStack() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const isInView = useInView(videoRef, {
    amount: 0.5
  });
  useEffect(() => {
    if (!videoRef.current) return;
    if (isInView) {
      videoRef.current.play().catch(() => {});
    } else {
      videoRef.current.pause();
    }
  }, [isInView]);
  return <section id="offer" className="w-full scroll-mt-20 bg-navy-mid px-5 py-12 sm:py-20" data-id="element-220" data-mp="1ogjv0328nbbu">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-[600px]" data-id="element-221" data-mp="23568dz8b1t0f">
        <h2 className="text-center font-display text-2xl font-bold text-white sm:text-4xl" data-id="element-222" data-mp="2c41e7a7ft137">
          Everything you get today
        </h2>
        <div className="mt-6 rounded-2xl border border-gold/45 bg-navy p-4 sm:mt-8 sm:p-6" data-id="element-223" data-mp="2m3sa9gbnbo5e">
          <ul data-id="element-224" data-mp="2h4xqoc5utvk8">
            {rows.map(([label, price]) => <li key={label} className="flex items-center justify-between gap-3 border-b border-dashed border-gold/30 py-2 last:border-b-0 sm:py-2.5" data-id="element-225" data-mp="2h5h35dcqjrqv">
                <span className="text-[13px] text-white/85 sm:text-sm" data-id="element-226" data-mp="msr5ckj8xye7">{label}</span>
                <span className="shrink-0 text-[13px] font-medium text-white/65 sm:text-sm" data-id="element-227" data-mp="2muh75j6c2qwb">
                  {price}
                </span>
              </li>)}
          </ul>
          <div className="my-4 h-px w-full bg-gold/45" data-id="element-228" data-mp="2vssvfejq9cll" />
          <div className="flex items-center justify-between" data-id="element-229" data-mp="30sxdva474heg">
            <span className="text-[13px] text-white/65 sm:text-sm" data-id="element-230" data-mp="30ui8t0ufa2cu">Total system value</span>
            <span className="text-lg font-medium text-white/55 line-through sm:text-xl" data-id="element-231" data-mp="35rigfg6x7d62">
              $350 USD
            </span>
          </div>
          <div className="mt-4 flex flex-col items-center rounded-xl border border-gold/30 bg-navy-mid py-5 text-center sm:py-6" data-id="element-232" data-mp="3fhtiex71ncab">
            <span className="text-sm font-medium text-gold" data-id="element-233" data-mp="3jjonmcs3i9td">Your investment today</span>
            <span className="font-display text-5xl font-bold text-gold sm:text-6xl" data-id="element-234" data-mp="3oj1f5atww52a">$27 USD</span>
            <p className="mt-2 px-4 text-xs text-white/65 sm:text-sm" data-id="element-235" data-mp="3th30y3iq2ihg">
              One-time payment · No subscription · Lifetime access · Instant PDF download
            </p>
          </div>
        </div>
        <div className="mt-6 sm:mt-8" data-id="element-236" data-mp="2gsrd5jju3o4">
          <div className="mb-8 flex flex-col items-center text-center" data-id="element-237" data-mp="2fr5s74wpys5">
            <span className="text-xs font-bold uppercase tracking-widest text-gold" data-id="element-238" data-mp="3toetgtqmdy2v">
              Get Instant Access Today
            </span>
            <h3 className="mt-2 font-display text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-239" data-mp="3po4kr9bg0tkb">
              And Receive This Exclusive Bonus at <span className="text-gold" data-id="element-240" data-mp="l7a4w2vt8sow">NO EXTRA COST</span>
            </h3>
            <p className="mt-4 text-base font-bold text-white sm:text-lg" data-id="element-241" data-mp="gglekqvva1rc">
              <span className="text-gold" data-id="element-242" data-mp="geqvli45ojpw">⚡</span> SOS KIT: 15-Minute Emergency ESL Lessons
            </p>
            <p className="mt-1 text-sm text-white" data-id="element-243" data-mp="cdf9vnoekimz">
              Your Zero-Prep Rescue Plan for Every Classroom Crisis
            </p>
            <div className="mt-6 w-full overflow-hidden rounded-xl border-2 border-gold bg-navy" data-id="element-244" data-mp="1465ybbzuh31o">
              <div className="relative aspect-square w-full" data-id="element-245" data-mp="oo4ymcz8crkk">
                <video ref={videoRef} src="https://cdn.magicpatterns.com/uploads/xp8jY4s6neKZZXLZCNinY3/IMG_0838.webm" className="h-full w-full object-cover" playsInline muted loop controls preload="none" data-id="element-246" data-mp="oqr5eaear31q" />
              </div>
            </div>
            <p className="mt-3 text-xs text-white/70" data-id="element-247" data-mp="1cdzb2tfn0e4a">
              Watch this before you decide — see exactly what&apos;s inside your exclusive bonus.
            </p>
          </div>
          <CTAButton label="YES, I WANT THE COMPLETE SYSTEM" href={CHECKOUT_URL} data-id="element-248" data-mp="ykhr57j1gzdq" />
          <TodayOfferCard data-id="element-249" data-mp="12mcro9t5b8qg" />
        </div>
      </motion.div>
    </section>;
}